import { LinearProgress } from "@material-ui/core";
import _ from "lodash";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import { getCompany, updateCompany, updateCompanyLogo } from "../ducks/actions";
import { getCompanyQuery } from "../ducks/selectors";
import { useNotifications } from "../notifications";
import CompanyOverviewEditDialog from "../shared/components/CompanyOverviewEditDialog";
import * as Messages from "./Messages";

const OverviewEdit = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { ok, ko } = useNotifications();
  const { id } = useParams();
  const {
    data: { data: company },
    loading
  } = useSelector(getCompanyQuery);

  const onClose = () => {
    history.push(`/companies/${id}/overview`);
  };

  const onLogoUpload = async ({ file }) => {
    try {
      await dispatch(updateCompanyLogo({ id, logo: file }));
      ok(Messages.CompanyUpdateSuccess);
    } catch (err) {
      ko(Messages.CompanyUpdateError);
    }
  };

  const onSubmit = async ({ industryId, ...values }) => {
    const industryIds = industryId ? [industryId] : [];
    try {
      await dispatch(
        updateCompany({
          id,
          company: {
            ...values,
            industry_industriables_attributes: _.concat(
              _.chain(company.industry_industriables)
                .filter(({ industry }) => !industryIds.includes(industry.id))
                .map(({ id }) => ({ id, _destroy: true }))
                .value(),
              _.chain(industryIds)
                .filter(id => !_.map(company.industry_industriables, "industry.id").includes(id))
                .map(id => ({ industry_id: id }))
                .value()
            )
          }
        })
      );
      await dispatch(getCompany({ id }));
      ok(Messages.CompanyUpdateSuccess);
      history.push(`/companies/${id}/overview`);
    } catch (err) {
      ko(Messages.CompanyUpdateError);
    }
  };

  if (loading) {
    return <LinearProgress />;
  }

  return (
    <CompanyOverviewEditDialog
      onClose={onClose}
      onLogoUpload={onLogoUpload}
      onSubmit={onSubmit}
      company={{
        ...company,
        industryId: company.industry_industriables?.[0]?.industry.id
      }}
    />
  );
};

export default OverviewEdit;
